import { computed, Injectable, signal } from "@angular/core";
import {
	IWeb3MigrationEstimationResponse,
	IWeb3MigrationStatusResponse,
	IWeb3MigrationSuccess
} from "@modules/web3/interface/web3.remote.interface";
import { UserStatus } from "@modules/web3/entities/user-status";

@Injectable({
	providedIn: "root"
})
export class Web3StateService {
	private readonly state = {
		$signedUpSignal: signal<IWeb3MigrationStatusResponse>(null),
		$estimateSignal: signal<IWeb3MigrationEstimationResponse | null>(null),
		$successSignal: signal<IWeb3MigrationSuccess | null>(null),
		$userStatusSignal: signal<UserStatus | null>(null),
		$userHoldsBestOrPan: signal<boolean | null>(null)
	};

	public readonly $signedUpSignal = this.state.$signedUpSignal.asReadonly();
	public readonly $estimateSignal = this.state.$estimateSignal.asReadonly();
	public readonly $successSignal = this.state.$successSignal.asReadonly();

	public readonly $userStatusSignal = computed(() => {
		if (this.$signedUpSignal()?.signedUp) {
			return UserStatus.OPTED_IN;
		}

		if (this.state.$userHoldsBestOrPan()) {
			return UserStatus.OPTED_OUT_HAS_ASSET;
		}

		return UserStatus.OPTED_OUT_NO_ASSET;
	});

	public setSignedUpSignal(signedUp: IWeb3MigrationStatusResponse): void {
		this.state.$signedUpSignal.set(signedUp);
	}

	public setEstimateSignal(estimation: IWeb3MigrationEstimationResponse | null): void {
		this.state.$estimateSignal.set(estimation);
	}

	public setSuccessSignal(success: IWeb3MigrationSuccess | null): void {
		this.state.$successSignal.set(success);
	}

	public setUserHoldsBestOrPan(holdsBestOrPan: boolean): void {
		this.state.$userHoldsBestOrPan.set(holdsBestOrPan);
	}

	public invalidateEstimateSignal(): void {
		this.state.$estimateSignal.set(null);
	}

	public invalidateSignedUpSignal(): void {
		this.state.$signedUpSignal.set(null);
	}

	public invalidateSuccessSignal(): void {
		this.state.$successSignal.set(null);
	}
}
